import React from 'react';
import TagStationModal from '../../shared/component/tag/TagStationModal';
import TagStationModalMobile from '../../shared/component/tag/mobile/TagStationModalMobile';
import { useTextTag } from '../../shared/hooks/useApi/useTextTag';
import { usePageOwnerIdentityStore } from '../../shared/store/pageOwnerIdentityStore';
import { canShowTextTagList } from '../../shared/util/visibility/textTagVisibility';
import { useAuth } from '../../shared/hooks/useApi/useAuth';

interface TextTagStationModalProps {
  isMobile: boolean;
  setIsUserInput: (isUserInput: boolean) => void;
}

const TextTagStationModal: React.FC<TextTagStationModalProps> = ({
  isMobile,
  setIsUserInput,
}) => {
  const pageOwner = usePageOwnerIdentityStore((s) => s.pageOwner);
  const { isOwner } = useAuth();
  const {
    tags,
    listOwnerAui,
    status,
    getTextTagList,
    updateTextTag,
    deleteTextTag,
  } = useTextTag();
  const canShowTags = canShowTextTagList({
    pageOwnerAui: pageOwner?.aui,
    listOwnerAui,
    status,
  });
  const visibleTags = canShowTags ? tags : [];

  const modalProps = {
    tags: visibleTags,
    loadTags: getTextTagList,
    loadKey: pageOwner?.aui ? `${pageOwner.aui}:${isOwner ? 'owner' : 'public'}` : null,
    updateTag: updateTextTag,
    deleteTag: deleteTextTag,
    setIsUserInput,
  };

  return isMobile
    ? <TagStationModalMobile {...modalProps} />
    : <TagStationModal {...modalProps} />;
};

export default TextTagStationModal;
